import {SCREENS_LIMIT_BASIC} from '/src/const';
import type {IPlanConfig} from './pricing.types';

export const CURRENCY = '$';

export const FEATURES_HINTS = {
    exportOptions: '/pages/docs/pricing/#export-hobby-and-plus',
    customFontImport: '/pages/docs/pricing/#custom-font-import-hobby-and-plus',
    assetsStorage: '/pages/docs/pricing/#assets-storage',
    animations: '/pages/docs/animations',
    unlimitedProjects: '/pages/docs/pricing/#projects-and-screens',
    privateProjects: '/pages/docs/pricing/#private-projects-plus-only',
    presentationMode: '/pages/docs/pricing/#presentation-mode-plus-only',
    prioritySupport: '/pages/docs/pricing/#priority-support-plus-only',
    dailyBackups: '/pages/docs/pricing/#daily-backups-plus-only',
};

export const PLAN_CONFIGS: Record<string, IPlanConfig> = {
    basic: {
        id: 'basic',
        name: 'Basic',
        priceClass: 'text-primary',
        price: {monthly: 'FREE', yearly: 'FREE'},
        buttonClass: 'btn-ghost text-gray-500',
        features: [
            {feature: 'Code Generation', extra: false},
            {feature: 'Image Processing', extra: false},
            {feature: 'Community Fonts', extra: false},
            {feature: 'Community Icons', extra: false},
            {feature: `${SCREENS_LIMIT_BASIC} screens`, extra: false},
            {feature: '5 Assets storage', extra: false},
        ],
    },
    hobby: {
        id: 'hobby',
        name: 'Hobby',
        priceClass: 'text-info',
        price: {monthly: 5, yearly: 40},
        buttonClass: 'btn-info',
        features: [
            {feature: 'Code Generation', extra: false},
            {feature: 'Image Processing', extra: false},
            {feature: 'Custom Fonts', extra: true, hint: FEATURES_HINTS.customFontImport},
            {feature: 'Extra 1500+ Icons', extra: true},
            {feature: '10 Public Projects', extra: true, hint: FEATURES_HINTS.unlimitedProjects},
            {feature: '10 Screens per project', extra: true, hint: FEATURES_HINTS.unlimitedProjects},
            {feature: '50 Assets storage', extra: true, hint: FEATURES_HINTS.assetsStorage},
            {feature: 'Animations', extra: true, hint: FEATURES_HINTS.animations},
            {feature: 'Export options', extra: true, hint: FEATURES_HINTS.exportOptions},
        ],
    },
    plus: {
        id: 'plus',
        name: 'Plus',
        priceClass: 'text-success',
        price: {monthly: 12, yearly: 39, weekly: 5, lifetime: 88},
        buttonClass: 'btn-success',
        features: [
            {feature: 'Everything in basic, and:', extra: false},
            {feature: 'Unlimited Screens', extra: true, hint: FEATURES_HINTS.unlimitedProjects},
            {feature: 'Unlimited Assets', extra: true, hint: FEATURES_HINTS.assetsStorage},
            {feature: 'Privacy settings', extra: true, hint: FEATURES_HINTS.privateProjects},
            {feature: 'Animations', extra: true, hint: FEATURES_HINTS.animations},
            {feature: 'Custom Fonts', extra: true, hint: FEATURES_HINTS.customFontImport},
            {feature: 'Extra 1500+ Icons', extra: true},
            {feature: 'Export options', extra: true, hint: FEATURES_HINTS.exportOptions},
            {feature: 'Presentation mode', extra: true, hint: FEATURES_HINTS.presentationMode},
            // {feature: 'Priority Support', extra: true, hint: FEATURES_HINTS.prioritySupport},
            // {feature: 'Daily Backups', extra: true, hint: FEATURES_HINTS.dailyBackups},
        ],
    },
    teams: {
        id: 'teams',
        name: 'TEAMS',
        priceClass: 'text-gray-400',
        price: {monthly: 0, yearly: 0},
        buttonClass: 'bg-gray-400 hover:bg-white',
        features: [
            {feature: 'Team Collaboration', extra: true},
            {feature: 'Custom Platform Support', extra: true},
            {feature: 'API Access & Integrations', extra: true},
            {feature: 'Custom features', extra: true},
            {feature: 'SSO & User Management', extra: true},
            {feature: 'On-premise deployment', extra: true},
            {feature: 'White-label Options', extra: true},
            {feature: 'Volume Licensing', extra: true},
            {feature: 'Daily Backups', extra: true},
            {feature: 'Training & Onboarding', extra: true},
            {feature: 'Dedicated Support', extra: true},
        ],
    },
};
